export default __webpack_public_path__ + "static/media/ESRB_E_10.fb9e97f6.png";